import { connect } from 'react-redux'
import QCListView from './QCListView'
import { listQc } from '../../../store/qc'

const mapDispatchToProps = {
  listQc
}

const mapStateToProps = (state, ownProps) => {
  return {
    qcResults: state.qc
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(QCListView)



// WEBPACK FOOTER //
// ./src/routes/QCList/components/QCListContainer.jsx